// extracted by mini-css-extract-plugin
module.exports = {"title":"search-SearchMusicItem__title--3mmIB","performer":"search-SearchMusicItem__performer--2Ppp_","piece":"search-SearchMusicItem__piece--1xsMt"};